import Actions from '../constants/Actions';
const TIMEOUT = 20000;

const HomeLoadCreator = {
  loadHome(context, {
    id
  }, done) {
    context.service.read('serviceslisting', {
        limit: '5'
      }, {
        timeout: TIMEOUT
      },
      (err, services) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_HOMESERVICE_SUCCESS, services);
        done();
      }
    );
    context.service.read('trendinglist', {}, {
        timeout: TIMEOUT
      },
      (err, list) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_HOMETRENDING_SUCCESS, list);
      }
    );
    context.service.read('popularsearch', {
        read_all: 'yes'
      }, {
        timeout: TIMEOUT
      },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_POPULARTOPICS_SUCCESS, data);
      }
    );
  },
  loadHomeEntity(context, {
    id
  }, done) {
    context.service.read('userfeedbackservice', {
        id
      }, {
        timeout: TIMEOUT
      },
      (err, data) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_USERFEEDBACK_SUCCESS, data);
        done();
      }
    );
  },
  loadMore(context, limitob, done) {
    context.service.read('serviceslisting', {
        limit: limitob.limit + 3
      }, {
        timeout: TIMEOUT
      },
      (err, services) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_HOMESERVICE_SUCCESS, services);
      }
    );
  },
  loadMoreWebsiteEntityFromCategory(context, content, done) {
    context.service.read('loadmorefromcategory', content, {
        timeout: TIMEOUT
      },
      (err, websites) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_WEBSITEMORE_SUCCESS, websites);
        done();
      }
    );
  },
  loadMoreProductEntityFromCategory(context, content, done) {
    context.service.read('loadmorefromcategory', content, {
        timeout: TIMEOUT
      },
      (err, products) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_PRODUCTMORE_SUCCESS, products);
        done();
      }
    );
  },
  loadMoreServiceEntityFromCategory(context, content, done) {
    context.service.read('loadmorefromcategory', content, {
        timeout: TIMEOUT
      },
      (err, services) => {
        if (err) {
          return done(err);
        }
        context.dispatch(Actions.LOAD_SERVICEMORE_SUCCESS, services);
        done();
      }
    );
  },
  setpopularsearch(context, content, done) {
    context.service.read('popularsearch', {
        searched_word: content.word,
        read_all: 'no'
      }, {
        timeout: TIMEOUT
      },
      (err, data) => {
        if (err) {
          return done(err);
        }
        if (data.length !== 0) {
          HomeLoadCreator.updatePopularSearch(context, {
            searched_word: content.word,
            count: data[0].count
          }, done);
        } else {
          HomeLoadCreator.createPopularSearch(context, {
            searched_word: content.word,
            link: content.link
          }, done);
        }
      }
    );
  },
  updatePopularSearch(context, content, done) {
    context.service.update('popularsearch', content, {
        timeout: TIMEOUT
      },
      (err, data) => {
        if (err) {
          return done(err);
        }
        done();
      }
    );
  },
  createPopularSearch(context, content, done) {
    context.service.create('popularsearch', content, {
        timeout: TIMEOUT
      },
      (err, data) => {
        if (err) {
          return done(err);
        }
        done();
      }
    );
  }
};

export default HomeLoadCreator;


// WEBPACK FOOTER //
// ./src/actions/HomeLoadCreator.js